<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="permissionForm ">
        <div class="col-lg-12 col-md-12">

            <div class="card custom-card">
                <div class="card-body">
                    <!-- <div >
                        <h3 class="main-content-label mb-1"><b>
                            permission Form 
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            permission Form
                        </p>
                    </div> -->
                    <div class=" d-flex align-items-center pl-3 mt-2">
                      <img alt="Logo" src="../../assets/img/users.png"
                          class="mh-45px pb-2">
                      <div class="ml-2">
                          <h3 class="main-content-label mb-1"><b>
                            Permission Form  
                              </b></h3>
                          <p class="text-muted card-sub-title mb-0">
                            User Permission Information
                          </p>
                      </div>
                  </div>
                    
                    <div class="row clearfix">
                      <!-- <div class="col-sm-1">
                        <div class="form-group">
                                <mat-form-field appearance="outline" class="example-full-width" >
                                    <mat-label>User Id</mat-label>
                                    <input  style="color:black;" matInput formControlName="UserId"
                                        placeholder="" >
                                </mat-form-field>
                        </div>
                    </div> -->
                      <div class="col-sm-2">
                          <div class="form-group">
                                  <mat-form-field appearance="outline" class="example-full-width" >
                                      <mat-label>User Name</mat-label>
                                      <input readonly  style="color:black;" matInput formControlName="Usernm"
                                          placeholder="" >
                                          <mat-error class="margin_tp"
                                          *ngIf="permissionForm.controls['Usernm'].touched && permissionForm.controls['Usernm'].errors?.required">
                                          This Field Is Mandatory
                                          </mat-error>
                                  </mat-form-field>

                          </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="form-group">
                          <mat-form-field appearance="outline" class="example-full-width" >
                            <mat-label>College/University</mat-label>
                                <mat-select required formControlName="CgUi" (selectionChange)="selsectClgUni($event)">
                                    <mat-option class="blue"  value="C" >College</mat-option>
                                    <mat-option class="red"  value="U" >University</mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                *ngIf="permissionForm.controls['CgUi'].touched && permissionForm.controls['CgUi'].errors?.required">
                                This Field Is Mandatory
                                </mat-error>
                        </mat-form-field>
                        </div>
                    </div>
                    <div *ngIf="showclg" class="col-sm-3">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width" >
                          <mat-label>College
                          </mat-label>
                          <mat-select required #select23 placeholder="" class="colorblack"
                          formControlName="CgId">
                          <mat-select-filter *ngIf="select23.focused" [placeholder]="'Filter'"
                            [displayMember]="'CgName'" [array]="collegedataList"
                            (filteredReturn)="filteredCollegeList =$event">
                          </mat-select-filter>
                          <mat-option *ngFor="let item of filteredCollegeList" [value]="item.CgCode">
                            {{item.CgCode}} - {{item.CgName}}
                          </mat-option>
                        </mat-select>
                        <mat-error class="margin_tp"
                        *ngIf="permissionForm.controls['CgId'].touched && permissionForm.controls['CgId'].errors?.required">
                        This Field Is Mandatory
                        </mat-error>
                      </mat-form-field>
                      </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <mat-form-field appearance="outline" class="example-full-width" >
                        <mat-label>User Role</mat-label>
                            <!-- <mat-select required formControlName="UserRole">
                                <mat-option class="blue" value="a">Admin</mat-option>
                                <mat-option class="red" value="s">Student</mat-option>
                            </mat-select> -->
                            <mat-select  #select33 placeholder="UserRole"
                            class="colorblack" formControlName="UserRole">
                            <mat-select-filter *ngIf="select33.focused" [placeholder]="'Filter'"  
                             [displayMember]="'CdDesc'"       
                                [array]="roleList"
                            (filteredReturn)="filteredListOfRole =$event"></mat-select-filter>
                             <mat-option    
                               *ngFor="let item of filteredListOfRole"   
                                [value]="item.CdCode">
                                 {{item.CdDesc}}
                                 </mat-option>    
                                </mat-select>
                            <mat-error class="margin_tp"
                            *ngIf="permissionForm.controls['UserRole'].touched && permissionForm.controls['UserRole'].errors?.required">
                            This Field Is Mandatory
                            </mat-error>
                    </mat-form-field>
                    </div>
                </div>
                  </div>
                    <div class="row clearfix">
                            
                        <div class="table-responsive table-container mt-8">
                          <table
                          class="datatable" class="table table-bordered text-nowrap">
                            <tr class="title-card-cust red_col">
                              <th class="text-center table_w" *ngIf="page == true">Pages</th>
                              <th class="text-center table_w" *ngIf="tab == true && page!== true">Tabs</th>
                              <th class="text-center table_w">Select All<mat-checkbox class="example-full-width mt-1" formControlName="PSelect" (change)="onSelectAllPagesChange($event)"> 
                                   </mat-checkbox>
                              </th>
                              <th class="text-center table_w">View</th>
                              <th class="text-center table_w">Create</th>
                              <th class="text-center table_w">Update</th>
                              <th class="text-center table_w">Delete</th>
                            </tr>
                            <tbody *ngIf="page == true || tab == true">
                              <tr *ngFor="let item of allPages">
                                <td *ngIf="page == true && item.IsTab == false"
                                  class="pt-1 pb-1 pr-4 text-left ml-3 pl-3 colorblack">
      
                                  {{item.PageName}}<br>
                                </td>
                                <td *ngIf="tab == true  && item.IsTab == true"
                                  class="pt-1 pb-1 pr-4 text-center ml-3 pl-3 colorblack">
                                  <!-- <span class="text-right ml-4" *ngIf="item.IsTab == true && item.isStockTab == true"> -->
                                 {{item.PageName}}
                                    <br>
                                  <!-- </span> -->
                                </td>
                              <td class="pt-1 pb-1 text-center colorblack">
                                <input type="checkbox" value="{{item.PageName}}" (change)="onSelectAllChange($event)"
                                    id="{{item.id}}" [checked]="item.PSelect" class=" mr-2" />
                              </td>
                                <td *ngIf="page == true && item.IsTab == false" class="pt-1 pb-1 text-center colorblack">
      
                                  <input type="checkbox" value="{{item.PageName}}" (change)="onViewChange($event)"
                                    id="{{item.id}}" [checked]="item.PView" class=" mr-2" />
                                  <!-- {{item.PView}}  -->
      
                                </td>
                                <td *ngIf="tab == true && item.IsTab == true" class="pt-1 pb-1 text-center colorblack">
                                  <input *ngIf="item.isadmin" type="checkbox" value="{{item.PageName}}" (change)="onCheckboxViewChange($event)"
                                  [checked]="item.PView" class="mr-2" [disabled]="!adminenable" />

                                  <input *ngIf="!item.isMaste" type="checkbox" value="{{item.PageName}}" 
                                  (change)="onCheckboxViewChange($event)"
                                    [checked]="item.PView" class="mr-2" [disabled]="!mastertabenable" />
                                    
                                    <input *ngIf="item.isSuper" type="checkbox" value="{{item.PageName}}" (change)="onCheckboxViewChange($event)"
                                    [checked]="item.PView" class="mr-2" [disabled]="!superenable" />
                                
                                    <input *ngIf="item.isProcc" type="checkbox" value="{{item.PageName}}" (change)="onCheckboxViewChange($event)"
                                    [checked]="item.PView" class="mr-2" [disabled]="!processenable" />
                               
                                    <input *ngIf="item.isInput" type="checkbox" value="{{item.PageName}}" (change)="onCheckboxViewChange($event)"
                                    [checked]="item.PView" class="mr-2" [disabled]="!inputenable" />
      
                                </td>
               
                                <td *ngIf="page == true && item.IsTab == false" class="pt-1 pb-1 colorblack text-center">
                              
                                  <input type="checkbox" [disabled]="!item.PView" value="{{item.PageName}}" id="{{item.id}}"
                                    (change)="onCreateChange($event)" [checked]="item.PCreate" class=" mr-2" />
                                </td>
                                <td *ngIf="tab == true && item.IsTab == true" class="pt-1 pb-1 colorblack text-center">
      
                                  <input type="checkbox" [disabled]="!item.PView" value="{{item.PageName}}"
                                    (change)="onCheckboxCreateChange($event)" [checked]="item.PCreate" class="mr-2" /><br>
      
                                </td>
                                <td *ngIf="page == true && item.IsTab == false" class="pt-1 pb-1 colorblack text-center">
      
                                  <input type="checkbox" [disabled]="!item.PView" value="{{item.PageName}}"
                                    (change)="onUpdateChange($event)" [checked]="item.PUpdate" class=" mr-2" />
                                </td>
                                <td *ngIf="tab == true && item.IsTab == true" class="pt-1 pb-1 colorblack text-center">
      
                                  <input type="checkbox" [disabled]="!item.PView" value="{{item.PageName}}"
                                    (change)="onCheckboxUpdateChange($event)" [checked]="item.PUpdate" class="mr-2" /><br>
      
                                </td>
                                <td *ngIf="page == true && item.IsTab == false" class="pt-1 pb-1 colorblack text-center">
      
                                  <input type="checkbox" [disabled]="!item.PView" value="{{item.PageName}}"
                                    (change)="onDeleteChange($event)" [checked]="item.PDelete" class=" mr-2" />
      
                                </td>
                                <td *ngIf="tab == true && item.IsTab == true" class="pt-1 pb-1 colorblack text-center">
      
      
                                  <input type="checkbox" [disabled]="!item.PView" value="{{item.PageName}}"
                                    (change)="onCheckboxDeleteChange($event)" [checked]="item.PDelete" class="mr-2" /><br>
      
      
                                </td>
      
                              </tr>
      
                            </tbody>
                         
                          </table>
                          </div>
                        <div class="col-sm-12 align-right">
                            <button *ngIf="submitButton" (click)="submit()" type="button" class="btn btn-primary my-2 me-2  btn-icon-text floatright btn btn-raised g-bg-blush2">
                                    Save
                            </button>
                            <button *ngIf="updateButton" (click)="update()" type="button" class="btn btn-primary my-2 me-2  btn-icon-text floatright btn btn-raised g-bg-blush2">
                              Update
                      </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>